import { PAGE_NAME, SINGLE_PACKAGE, TRIPLE_PACKAGE } from '../../../events';

export const GROUP = 'user_impressions';
export const SUB_GROUP = 'content_impression';
export const ACTION_TYPE = 'impression';

export const createBaseEventParams = ({ general = {}, requestContext: { current_user, page_ctx_id }, packagesCount }) => {
    const { gigId, sellerId } = general;
    const userId = current_user ? current_user.id : null;
    const packageType = packagesCount === 3 ? TRIPLE_PACKAGE : SINGLE_PACKAGE;

    return {
        group: GROUP,
        sub_group: SUB_GROUP,
        gig: { id: gigId, packages_type: packageType },
        user: { id: userId },
        seller: { id: sellerId },
        page: { ctx_id: page_ctx_id, name: PAGE_NAME },
        page_name: PAGE_NAME,
        action: {
            type: ACTION_TYPE
        },
        userId,
        out_of_session: false
    };
};
